import React, { useEffect, useState } from "react"
import { Col, Container, Modal, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import API from "../../common/API"
import { parsedUser } from "../../common/GetCurrentUser"
import EmployeAddEdit from "../Employees/EmployeAddEdit"

const AddEditProjectEmployee = props => {
  const { t } = useTranslation("global")
  const user = parsedUser()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [records, setRecords] = useState<any>([])
  const [search, setSearch] = useState<string>("")
  const [showAddEditEmployee, setShowAddEditEmployee] = useState<boolean>(false)
  const getRecords = async () => {
    try {
      let filterObj = {
        page: 0,
        quantity: 10,
        organizationId: user.OrganizationId,
        search: search,
      }
      setIsLoading(true)
      let request = await API.postAction("Employee/list", filterObj)

      setRecords(request.data.response)
      console.log("request remote")
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }
  const toggleAddEditEmployee = () => {
    setShowAddEditEmployee(!showAddEditEmployee)
    if (showAddEditEmployee) {
      getRecords()
    }
  }
  const assignEmployee = async employee => {
    try {

      let query = {
        projectId: props.parent.id,
        employeeId: employee.employeeId,
      }
      setIsLoading(true)
      let request = await API.postAction("projects/AssignEmployee", query)
      props.toggle()
      console.log("request remote")
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getRecords()
  }, [])

  return (
    <>
      {showAddEditEmployee && (
        <EmployeAddEdit
          cssClass="modalRight"
          toggle={toggleAddEditEmployee}
          projectId={props.parent.id}
        />
      )}
      <Modal
        show={true}
        onHide={props.toggle}
        size={props.modalSize ? props.modalSize : "lg"}
        className={props.cssClass + " modalRight"}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t("Assign Employee")}

            <button
              className="btn-sm btn btn-secondary ms-2"
              onClick={() => toggleAddEditEmployee()}
            >
              <i className="fas fa-plus me-2"></i>
              {t("Add Employee")}
            </button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col xs={12}>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("Search") ?? ""}
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                />
              </Col>
              <Col xs={12}>
                <table className="table table-striped table-bordered mt-4">
                  <thead>
                    <tr>
                      <th>{t("Name")}</th>
                      <th>{t("Last Name")}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {records &&
                      records.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item.firstName}</td>
                            <td>{item.lastName}</td>
                            <td className="text-end">
                              <button
                                className="btn btn-primary btn-sm"
                                onClick={() => assignEmployee(item)}
                              >
                                {t("Assign")}
                              </button>
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </table>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default AddEditProjectEmployee
